import React from 'react';
import moize from 'moize';
import Folder from '@material-ui/icons/Folder';

const FileExplorerIconAndCaption = () => <Folder className="icon" />;
export default moize.reactSimple(FileExplorerIconAndCaption);
